import getTimezoneAbbr from 'Helper/getTimezoneAbbr';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

const ClockTime = () => {
  const cookies = new Cookies();
  const organization = cookies.get('organization');
  const timezone = organization?.timezone;

  const time = moment().format('HH:mm:ss');
  const abbr = getTimezoneAbbr(timezone);

  const [clockTime, setClockTime] = useState(`${time} ${abbr}`);

  useEffect(() => {
    const timer = setInterval(() => {
      const time = moment().format('HH:mm:ss');
      const abbr = getTimezoneAbbr(timezone);

      setClockTime(`${time} ${abbr}`);
    }, 1000);
    return () => clearInterval(timer);
  }, [timezone]);

  return <span>{clockTime}</span>;
};

export default ClockTime;
